import { render } from "./OrderReceipt.vue?vue&type=template&id=1ca6d6d2&scoped=true"
import script from "./OrderReceipt.vue?vue&type=script&lang=js"
export * from "./OrderReceipt.vue?vue&type=script&lang=js"

import "./OrderReceipt.vue?vue&type=style&index=0&id=1ca6d6d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca6d6d2"]])

export default __exports__